class HairBox {
  constructor() {
    this.bindCards();
    document.addEventListener('shopify:section:load', () => this.bindCards());
  }

  bindCards() {
    document.querySelectorAll('[data-card-slider]:not([data-hair-box-bound])').forEach(card => {
      card.setAttribute('data-hair-box-bound', '');

      card.addEventListener('mouseenter', () => {
        if (window.innerWidth >= 1024 && card.swiper) {
          card.swiper.slideTo(1);
        }
      });

      card.addEventListener('mouseleave', () => {
        if (window.innerWidth >= 1024 && card.swiper) {
          card.swiper.slideTo(0);
        }
      });
    });
  }
}

new HairBox();
